// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"f774c264","330":"7513ecc0","599":"8fd52746","964":"d5d0a651","977":"d9dbd40e"}[chunkId] + ".chunk.js";
};